export default __webpack_public_path__ + "static/media/sohargate.75ad7361.png";